import script from "./InternationalStandardMetadataList.vue?vue&type=script&setup=true&lang=js"
export * from "./InternationalStandardMetadataList.vue?vue&type=script&setup=true&lang=js"

import "./InternationalStandardMetadataList.vue?vue&type=style&index=0&id=5409313e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5409313e"]])

export default __exports__